import React, { Component, createContext } from 'react'
import Firebase from 'firebase/app'
import { getUserTypeOrThrow, getUserTeam } from '../../helpers/user'
import 'firebase/auth'
import { Loader, Dimmer } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

export const AuthContext = createContext()

class AuthProvider extends Component {
  state = {
    user: null,
    loading: true
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.node
  }

  componentDidMount = () => {
    Firebase.auth().onAuthStateChanged(async user => {
      if (user)
        try {
          this.setState({
            user: {
              ...user,
              type: await getUserTypeOrThrow(user),
              team: await getUserTeam(user)
            }
          })
        } catch (e) {
          return this.signOut()
        }
      else this.setState({ user: null })
      this.setState({ loading: false })
      this.props.history.push('/', {
        from: this.props.location.pathname
      })
    })
  }

  signOut = () => {
    return Firebase.auth().signOut()
  }

  syncTeam = () => {
    const { user } = this.state
    return getUserTeam(user).then(team => {
      return this.setState({
        user: {
          ...user,
          team
        }
      })
    })
  }

  render() {
    return this.state.loading ? (
      <Dimmer active>
        <Loader />
      </Dimmer>
    ) : (
      <AuthContext.Provider
        value={{
          user: this.state.user,
          signOut: this.signOut,
          syncTeam: this.syncTeam
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    )
  }
}

export default withRouter(AuthProvider)



// WEBPACK FOOTER //
// ./src/components/AuthProvider/index.jsx